(ns cms.editor.primitives
  (:require [cms.editor.core :refer [schema->enum
                                     schema-editor]]))

(defmethod schema-editor :string [_ _ schema node&]
  (let [enum (schema->enum schema)]
    (case (count enum)
      1 nil
      
      0 [:input 
         {:type :text 
          :name "str"
          :value @node&
          :on-change #(reset! node& (.. % -target -value))}]
      
      ;else 
      (into 
        [:select
         {:value (or @node& (first enum))
          :on-change 
          #(reset! node& (.. % -target -value))}]
        (for [opt enum]
          [:option {:value opt} 
           opt]))
      )))

(defmethod schema-editor :integer [_ _ schema node&]
  [:input 
   {:type :number
    :step 1
    :name "num" 
    :value @node&
    :on-change 
    (fn [evt]
      (let [v (js/parseInt (.. evt -target -value))]
        (reset! 
          node& 
          (if (js/isNaN v) 0 v))))}])

(defmethod schema-editor :number [_ _ schema node&]
  [:input 
   {:type :number
    :step :any
    :name "num" 
    :value @node&
    :on-change 
    (fn [evt]
      (let [v (js/parseFloat (.. evt -target -value))]
        (reset! 
          node& 
          (if (js/isNaN v) 0 v))))}])
